package com.tovtalk.utils.deeplink

/**
 * Holds the route to navigate to after successful login.
 * Set when user tries to view a post/profile without being logged in (e.g. from deep link)
 * and clicks "Login". Cleared after navigation.
 */
object RedirectAfterLogin {
    var route: DeepLinkRoute? = null
}
